import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { InputComponent } from './input/input.component';
import { GiftCardBalanceRoutingModule } from './gift-card-balance-routing.module';
import { DetailsComponent } from './details/details.component';
import { DsiCurrencyModule } from 'src/app/shared/dsi-currency/dsi-currency.module';
import { GiftCardIDModule } from 'src/app/shared/gift-card-id/gift-card-id.module';
import { SkeletonScreenModule } from '@daysmart/angular-skeleton-screen';
import { QaModule } from '@daysmart/angular-qa-module';

@NgModule({
    declarations: [InputComponent, DetailsComponent],
    imports: [
        CommonModule,
        GiftCardBalanceRoutingModule,
        MatButtonModule,
        MatCardModule,
        MatInputModule,
        ReactiveFormsModule,
        MatTableModule,
        DsiCurrencyModule,
        GiftCardIDModule,
        SkeletonScreenModule,
        QaModule,
    ],
})
export class GiftCardBalanceModule {}
